<ng-container *transloco="let t;">
    <!-- Samsung help modal template -->
    <div class="modal-header">
        <h4 class="modal-title">{{t('Bankid samsung browser modal title (Signing page - section) - Fix BankID on Samsung Internet')}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <ol>
            <li [innerHTML]="getSafeHtml('BankId samsung browser instruction text (Signing page - section) - Open phone settings')"></li>
            <li [innerHTML]="getSafeHtml('BankId samsung browser instruction text (Signing page - section) - Go to Apps - Samsung Internet - Useful features')"></li>
            <li [innerHTML]="getSafeHtml('BankId samsung browser instruction text (Signing page - section) - Disable - Open app links in browser')"></li>
        </ol>
        <p [innerHTML]="getSafeHtml('BankId samsung browser instruction text (Signing page - section) - Alternative: Use Chrome browser instead')"></p>
    </div>
</ng-container>